import { MutableRefObject } from 'react'
import { GridApiPro } from '@microservices/wiskey-react-table-component'

import { SYSTEM_SELECT_COLUMN } from '@constants'
import { RestrictionData, RESTRICTION_TYPE, RestrictionDTO } from '@types'

const EXCLUDED_ORDER_FIELDS = new Set([SYSTEM_SELECT_COLUMN, 'actions', 'linkToForm'])

export const buildOrderRestrictionsFromVisibleColumns = (
  apiRef: MutableRefObject<GridApiPro>,
  entityId: string,
  entityRestrictions?: RestrictionData
) => {
  const visibleColumns = apiRef.current?.getVisibleColumns?.() ?? []

  const orderRestrictions: RestrictionDTO[] = visibleColumns
    .filter(col => col.field && !EXCLUDED_ORDER_FIELDS.has(col.field))
    .map((col, index) => {
      const fieldCode = col.field as string
      const existing = entityRestrictions?.order?.find(r => r.fieldCode === fieldCode)

      return {
        ...(existing?.id ? { id: existing.id } : {}),
        fieldCode,
        fieldName: (col.headerName as string) ?? fieldCode,
        viewId: entityId,
        restrictionType: RESTRICTION_TYPE.ORDER,
        value: index,
      }
    })

  const changedOrders = orderRestrictions.filter(restriction => {
    const existing = entityRestrictions?.order?.find(r => r.fieldCode === restriction.fieldCode)

    return existing === undefined || Number(existing.value) !== Number(restriction.value)
  })

  return { orderRestrictions, changedOrders }
}
